import { render, staticRenderFns } from "./DeductionsCategory.vue?vue&type=template&id=4ffca5ca"
import script from "./DeductionsCategory.vue?vue&type=script&lang=js"
export * from "./DeductionsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports